import { gql } from '@apollo/client'

// Which features the account has switched on, for deciding what the profile
// renders. `locations.menus` is already limited to visible menus server-side.
export const GET_PROFILE_FEATURES = gql`
  query ProfileFeatures {
    currentShop {
      id
      isGiftCardAvailable
      checkoutSetting {
        hideGiftCards
      }
    }
    currentAccount {
      id
      locations {
        id
        reservationAllowed
        menus {
          id
          onlineOrdering
          pickupSetting {
            id
          }
          deliverySettings {
            __typename
          }
        }
      }
    }
  }
`
